import React, { useEffect } from 'react';

const LoanAgainstSecuritiesPage = () => {
  useEffect(() => {
    const link = document.createElement("link");
    link.href = "https://cdn.jsdelivr.net/npm/tailwindcss@2.2.19/dist/tailwind.min.css";
    link.rel = "stylesheet";
    link.id = "tailwind-mutualfund"; // Add ID so you can remove it later if needed
    document.head.appendChild(link);

    return () => {
      // Optional: Clean up when component unmounts
      document.getElementById("tailwind-mutualfund")?.remove();
    };
  }, []);
  return (
    <>
      {/* <!-- Hero Section --> */}
      <section class="bg-blue-50 py-16 text-center">
        <h1 class="text-4xl font-bold text-blue-900 mb-4">Get Instant Loan Against Your Securities</h1>
        <p class="text-lg text-gray-700 mb-6">Unlock the value of your shares, mutual funds, bonds, or insurance policies without selling them.</p>
        {/* <a href="#" class="px-6 py-3 bg-gradient-to-r from-teal-400 to-green-400 text-white rounded-full font-semibold shadow hover:shadow-lg">Apply for Loan</a> */}
        <div ><a class="btn btn-primary" href="https://gpsfinvest.investwell.app/app/#/login">Apply for Loan</a></div>
      </section>

      {/* <!-- What is Loan Against Securities --> */}
      <section class="py-16 bg-white">
        <div className='row'>
          <div className='col-md-12' style={{ display: 'flex', justifyContent: 'center' }}>
            <img src='/images/loan_against_mutualfunds.png' style={{ height: '300px' }} />
          </div>
          <div className='col-md6'>
            <div class="max-w-4xl mx-auto px-4 text-center">
              <h2 class="text-3xl font-bold text-gray-900 mb-6">What is a Loan Against Securities?</h2>
              <p class="text-lg text-gray-600">Loan Against Securities (LAS) is a facility that allows you to borrow funds by pledging your financial assets like shares, mutual funds, bonds, or insurance policies. It helps you meet short-term financial needs without liquidating your long-term investments.</p>
            </div>
          </div>
        </div>
      </section>

      {/* <!-- Why Choose GPS Finvest --> */}
      <section class="py-16 bg-green-50">
        <div class="max-w-6xl mx-auto px-4 text-center">
          <h2 class="text-3xl font-bold mb-10 text-gray-800">Why Choose GPS Finvest for LAS?</h2>
          <div class="grid md:grid-cols-4 gap-6 text-left">
            <div class="hover-card bg-white p-6 rounded-lg shadow">
              <img src="/images/Quick_Processing.png" alt="Large Cap" className="w-16 h-16 mx-auto mb-4" />
              <h3 class="text-lg font-semibold text-green-700 mb-2">Quick Processing</h3>
              <p>Fast approvals with minimal paperwork and real-time eligibility check.</p>
            </div>
            <div class="hover-card bg-white p-6 rounded-lg shadow">
              <img src="/images/Sale.png" alt="Large Cap" className="w-16 h-16 mx-auto mb-4" />
              <h3 class="text-lg font-semibold text-green-700 mb-2">No Asset Sale</h3>
              <p>Keep your investments intact while accessing funds when you need them.</p>
            </div>
            <div class="hover-card bg-white p-6 rounded-lg shadow">
              <img src="/images/Flexible_Repayment.png" alt="Large Cap" className="w-16 h-16 mx-auto mb-4" />
              <h3 class="text-lg font-semibold text-green-700 mb-2">Flexible Repayment</h3>
              <p>Repay interest monthly and principal anytime within the loan tenure.</p>
            </div>
            <div class="hover-card bg-white p-6 rounded-lg shadow">
              <img src="/images/Competitive.png" alt="Large Cap" className="w-16 h-16 mx-auto mb-4" />
              <h3 class="text-lg font-semibold text-green-700 mb-2">Competitive Interest Rates</h3>
              <p>Enjoy low-interest loans with high credit limits based on your portfolio.</p>
            </div>
          </div>
        </div>
      </section>

      {/* <!-- How to Avail Loan --> */}
      <section class="py-16 bg-white">
        <div class="max-w-5xl mx-auto px-4 text-center">
          <h2 class="text-3xl font-bold mb-10 text-gray-800">How to Avail Loan Against Securities</h2>
          <div class="grid md:grid-cols-4 gap-6 text-left">
            <div class="hover-card bg-blue-50 p-6 rounded-lg shadow">
              <h3 class="text-lg font-semibold text-blue-800 mb-2">1. Apply Online</h3>
              <p>Fill out the quick online application with your security details.</p>
            </div>
            <div class="hover-card bg-blue-50 p-6 rounded-lg shadow">
              <h3 class="text-lg font-semibold text-blue-800 mb-2">2. Get Eligibility</h3>
              <p>We assess your portfolio and provide instant eligibility confirmation.</p>
            </div>
            <div class="hover-card bg-blue-50 p-6 rounded-lg shadow">
              <h3 class="text-lg font-semibold text-blue-800 mb-2">3. Pledge Securities</h3>
              <p>Digitally pledge shares, mutual funds, or policies from your account.</p>
            </div>
            <div class="hover-card bg-blue-50 p-6 rounded-lg shadow">
              <h3 class="text-lg font-semibold text-blue-800 mb-2">4. Receive Loan</h3>
              <p>Funds are credited to your bank within 24 hours post-verification.</p>
            </div>
          </div>
        </div>
      </section>

      {/* <!-- Comparison Table --> */}
      <section class="py-16 bg-green-50" >
        <div class="max-w-6xl mx-auto px-4">
          <h2 class="text-3xl font-bold text-center text-gray-800 mb-10">Comparison: LAS vs Selling Investments</h2>
          <div class="overflow-x-auto rounded-lg shadow">
            <table class="min-w-full text-sm text-left border border-gray-200">
              <thead class="bg-green-200 text-green-900">
                <tr>
                  <th class="px-6 py-4 border">Feature</th>
                  <th class="px-6 py-4 border">Loan Against Securities</th>
                  <th class="px-6 py-4 border">Selling Investments</th>
                </tr>
              </thead>
              <tbody class="bg-white text-gray-800">
                <tr class="tabletr transition">
                  <td class="px-6 py-4 border">Ownership</td>
                  <td class="px-6 py-4 border">Retained</td>
                  <td class="px-6 py-4 border">Lost</td>
                </tr>
                <tr class="tabletr transition">
                  <td class="px-6 py-4 border">Capital Gains Tax</td>
                  <td class="px-6 py-4 border">Not Applicable</td>
                  <td class="px-6 py-4 border">Applicable</td>
                </tr>
                <tr class="tabletr transition">
                  <td class="px-6 py-4 border">Future Returns</td>
                  <td class="px-6 py-4 border">Continued</td>
                  <td class="px-6 py-4 border">Lost</td>
                </tr>
                <tr class="tabletr transition">
                  <td class="px-6 py-4 border">Credit Limit</td>
                  <td class="px-6 py-4 border">Up to 85% of asset value</td>
                  <td class="px-6 py-4 border">N/A</td>
                </tr>
                <tr class="tabletr transition">
                  <td class="px-6 py-4 border">Processing Time</td>
                  <td class="px-6 py-4 border">1 Day</td>
                  <td class="px-6 py-4 border">Instant</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>


      {/* <!-- What is Loan Against Mutual Funds (Updated) --> */}
      <section class="py-16 bg-white">
        <div class="max-w-4xl mx-auto px-4 text-center">
          <h2 class="text-3xl font-bold text-gray-900 mb-6">Instant Loan on Mutual Funds – No Paperwork Needed</h2>
          <p class="text-lg text-gray-600">
            GPS Finvest offers a quick and fully digital loan facility against your mutual fund investments. No paperwork, no branch visits – just link your portfolio, get instant eligibility, and receive funds directly in your bank account. Your investments stay intact while you access liquidity in minutes.
          </p>
        </div>
      </section>

      {/* <!-- Why Choose GPS Finvest (Updated) --> */}
      <section class="py-16 bg-green-50">
        <div class="max-w-6xl mx-auto px-4 text-center">
          <h2 class="text-3xl font-bold mb-10 text-gray-800">Why Choose GPS Finvest for Mutual Fund Loans?</h2>
          <div class="grid md:grid-cols-4 gap-6 text-left">
            <div class="hover-card bg-white p-6 rounded-lg shadow">
              <h3 class="text-lg font-semibold text-green-700 mb-2">100% Paperless</h3>
              <p>Completely online approval with zero documentation.</p>
            </div>
            <div class="hover-card bg-white p-6 rounded-lg shadow">
              <h3 class="text-lg font-semibold text-green-700 mb-2">Instant Credit</h3>
              <p>Link mutual funds and get the money directly in your bank account.</p>
            </div>
            <div class="hover-card bg-white p-6 rounded-lg shadow">
              <h3 class="text-lg font-semibold text-green-700 mb-2">No Impact on Holdings</h3>
              <p>Your mutual fund investments remain untouched and continue to grow.</p>
            </div>
            <div class="hover-card bg-white p-6 rounded-lg shadow">
              <h3 class="text-lg font-semibold text-green-700 mb-2">High Loan Value</h3>
              <p>Get up to 80% of your mutual fund value as loan.</p>
            </div>
          </div>
        </div>
      </section>

      {/* <!-- Loan Calculator Section --> */}
      <section class="py-16 bg-white">
        <div class="max-w-4xl mx-auto px-4 text-center">
          <h2 class="text-3xl font-bold text-gray-900 mb-6">Check Your Loan Eligibility</h2>
          <p class="text-lg text-gray-600 mb-6">Estimate your eligible loan amount based on your mutual fund value.</p>
          <div class="bg-blue-50 p-6 rounded-lg shadow-md max-w-md mx-auto text-left">
            <label class="block text-gray-700 mb-2 font-semibold" for="fundValue">Enter Mutual Fund Value (₹):</label>
            <input type="number" id="fundValue" class="w-full p-3 rounded border border-gray-300 mb-4" placeholder="e.g. 500000" />
            <div ><div class="w-full btn btn-primary" href="#">Calculate Loan Amount</div></div>
            <div id="loanResult" class=" mt-4 text-green-700 font-semibold text-center text-xl"></div>
          </div>
        </div>
      </section>
    </>
  );
};

export default LoanAgainstSecuritiesPage;
